import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TemplateSlotModule } from 'src/app/shared/components/template-slot/template-slot.module';

import { CalculatorTaxRoutingModule } from './calculator-tax-routing.module';
import { CalculatorTaxComponent } from './calculator-tax.component';
import { CalculateTaxBoxComponent } from './components/calculate-box/calculate-box.component';
import { IncomeInputNumberModule } from './components/input-number/input-number.module';
import { CalculatorAppDetailModule } from './components/app-detail/app-detail.module';
import { SlidingTabsModule } from 'src/app/shared/components/sliding-tabs/sliding-tabs.module';
import { CalculatorPaystationDetailModule } from './components/paystation-detail/paystation-detail.module';


@NgModule({
  declarations: [
    CalculatorTaxComponent,
    CalculateTaxBoxComponent,
  ],
  imports: [
    CommonModule,
    CalculatorTaxRoutingModule,
    IncomeInputNumberModule,
    CalculatorAppDetailModule,
    CalculatorPaystationDetailModule,
    NgbDropdownModule,
    ReactiveFormsModule,
    TemplateSlotModule,
    FormsModule,
    SlidingTabsModule,
  ]
})
export class CalculatorTaxModule { }
